var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Chip, Grid, Typography, useMediaQuery } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ExportIconSVG } from '../../../assets/customIcons';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { MuiStack } from '../../../components';
import { DesktopTabComponent } from '../../../components/molecules/desktopTabComponent';
import HeaderCatalogPageComponent from '../../../components/templates/headerCatalogPageUpdated';
import { ESystemName, LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { resetState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { secondaryTextGray } from '../../../theme/palette';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import CardView from '../../proprietaryWarranty/pages/proprietaryCardView';
import { CancelIconSVG, PrintIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import CancelDocument from '../components/cancelDocument';
import { CancellationReasonWPIListAPICall, CancelWorkPurchaseInvoiceAPICall, WPIPagingAPICall } from '../services/apiCall';
import { viewTypeOptions, WorkPurchaseInvoiceKeys, WorkPurchaseInvoicePagingAPIUrl, WorkPurchaseInvoiceStatusEnum, WPIApiKeys } from '../services/entity';
var WorkPurchaseInvoice = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$filterValue, _crud$WorkPurchaseInv;
    var crud = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; });
    var _a = useState('list'), activeView = _a[0], setActiveView = _a[1];
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var _b = useState(false), openCancelPopUp = _b[0], setOpenCancelPopUp = _b[1];
    var _c = useState(''), rowId = _c[0], setRowId = _c[1];
    var navigate = useNavigate();
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var dispatch = useDispatch();
    var filterValue = (_crud$filterValue = crud['filterValue']) === null || _crud$filterValue === void 0 ? void 0 : _crud$filterValue.data;
    var GetCancellationReasonWPIList = function () { return CancellationReasonWPIListAPICall({
        request: {
            SystemName: WorkPurchaseInvoiceKeys.WPISystemName
        }
    }); };
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var appDispatch = useAppDispatch();
    var _d = useState([]), dataList = _d[0], setDataList = _d[1];
    var _e = useState(1), currentPage = _e[0], setCurrentPage = _e[1];
    var _f = useState(true), hasMore = _f[0], setHasMore = _f[1];
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _g = useState(new Set()), uniqueIds = _g[0], setUniqueIds = _g[1];
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var _h = useState(viewTypeOptions.length > 0 && isAllViewActive ? viewTypeOptions[0] : viewTypeOptions[1]), selectedListVariant = _h[0], setSelectedListVariant = _h[1];
    var getRequest = function () {
        var _getLocalStorageItem3;
        var request = {
            OrganizationId: UserOrganization,
            ParentOrganizationId: UserParentOrganization,
            Type: WorkPurchaseInvoiceKeys.WorkPurchaseInvoiceType,
            IdentityId: selectedListVariant === "My work purchase invoice" ? (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 || (_getLocalStorageItem3 = _getLocalStorageItem3.data) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.IdentityId : undefined
        };
        return request;
    };
    useEffect(function () {
        WPIPagingAPICall({
            key: WorkPurchaseInvoiceKeys.Paging,
            request: getRequest(),
            url: WorkPurchaseInvoicePagingAPIUrl
        });
    }, [selectedListVariant, filterValue]);
    var getIcon = function (name) {
        switch (name) {
            case 'CancelWPI':
                return /*#__PURE__*/ React.createElement(CancelIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Print':
                return /*#__PURE__*/ React.createElement(PrintIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'Export':
                return /*#__PURE__*/ React.createElement(ExportIconSVG, {
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var customActionColumns = [{
            field: 'DocumentNumber',
            headerName: 'Document No.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentNumber ? "".concat(row === null || row === void 0 ? void 0 : row.DocumentNumber) : '-'; },
            minWidth: 200
        }, {
            field: 'DocumentDate',
            headerName: 'Document Date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentDate ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.DocumentDate)) : '-'; },
            minWidth: 200
        }, {
            field: 'SupplierName',
            headerName: 'Supplier',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.SupplierName ? "".concat(row === null || row === void 0 ? void 0 : row.SupplierName) : '-'; },
            minWidth: 200
        }, {
            field: 'JobCardReferenceNo',
            headerName: 'Job card reference no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.JobCardNo ? "".concat(row === null || row === void 0 ? void 0 : row.JobCardNo) : '-'; },
            minWidth: 200
        }, {
            field: 'VINReference',
            headerName: 'VIN reference',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.VIN ? "".concat(row === null || row === void 0 ? void 0 : row.VIN) : '-'; },
            minWidth: 200
        }, {
            field: 'TotalAmount',
            headerName: 'Total amt.',
            valueFormatter: function (val, row) {
                var _Number;
                return val ? (_Number = Number(val)) === null || _Number === void 0 ? void 0 : _Number.toFixed(2) : '-';
            },
            minWidth: 200
        }, {
            field: 'ServiceAdvisor',
            headerName: 'Service advisor',
            valueFormatter: function (value, row) {
                var _row$ServiceAdvisor;
                return (_row$ServiceAdvisor = row === null || row === void 0 ? void 0 : row.ServiceAdvisor) !== null && _row$ServiceAdvisor !== void 0 ? _row$ServiceAdvisor : '';
            },
            minWidth: 200
        }, {
            field: 'Status',
            headerName: 'Status',
            renderCell: function (params) {
                var _params$row, _params$row$Status, _params$row2, _params$row3;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'center',
                    height: '100%'
                }, params !== null && params !== void 0 && (_params$row = params.row) !== null && _params$row !== void 0 && _params$row.Status ? /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$Status = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Status) !== null && _params$row$Status !== void 0 ? _params$row$Status : '-',
                    size: "small",
                    variant: "outlined",
                    id: 'status',
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.Status) == 'Cancelled' ? /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "red"
                    }) : undefined
                }) : /*#__PURE__*/ React.createElement(Typography, null, '-'));
            },
            minWidth: 200
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _this = this;
                var _params$row4, _params$row5, _params$row6;
                var menuFeatures = cloneDeep(storedMenuFeatures);
                var list = menuFeatures === null || menuFeatures === void 0 ? void 0 : menuFeatures.filter(function (data) { return !(data.Name == 'CancelWPI'); });
                var data = (params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.Status) === (WorkPurchaseInvoiceStatusEnum === null || WorkPurchaseInvoiceStatusEnum === void 0 ? void 0 : WorkPurchaseInvoiceStatusEnum.Draft) || (params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.Status) === (WorkPurchaseInvoiceStatusEnum === null || WorkPurchaseInvoiceStatusEnum === void 0 ? void 0 : WorkPurchaseInvoiceStatusEnum.PendingApproval) || (params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.Status) === (WorkPurchaseInvoiceStatusEnum === null || WorkPurchaseInvoiceStatusEnum === void 0 ? void 0 : WorkPurchaseInvoiceStatusEnum.Rejected) ? storedMenuFeatures : list !== null && list !== void 0 ? list : [];
                return data === null || data === void 0 ? void 0 : data.map(function (data) {
                    var _a;
                    return React.createElement(GridActionsCellItem, {
                        label: data === null || data === void 0 ? void 0 : data.DisplayName,
                        icon: getIcon(data === null || data === void 0 ? void 0 : data.Name),
                        id: "action-icon",
                        showInMenu: true,
                        onClick: function (e) { return __awaiter(_this, void 0, void 0, function () {
                            var _params$row7;
                            return __generator(this, function (_a) {
                                if ((data === null || data === void 0 ? void 0 : data.Name) == 'CancelWPI') {
                                    handleRowCancelClick(params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.id);
                                }
                                return [2 /*return*/];
                            });
                        }); },
                        sx: (_a = {
                                fontSize: 14
                            },
                            _a["& .MuiListItemIcon-root"] = {
                                minWidth: 24
                            },
                            _a)
                    });
                });
            },
            minWidth: 50
        }];
    var handleRowClick = function (id) {
        dispatch(resetState(WPIApiKeys));
        navigate("/createWorkPurchaseInvoice/".concat(id, "?mode=edit"));
    };
    var handleRowCancelClick = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRowId(id);
                    setOpenCancelPopUp(true);
                    return [4 /*yield*/, appDispatch(showSurface(_objectSpread(_objectSpread({}, IS_MOBILE ? {
                            type: 'Drawer',
                            containerProps: {
                                PaperProps: {
                                    sx: {
                                        p: 2,
                                        width: {
                                            xs: '100%',
                                            sm: '400px'
                                        },
                                        borderRadius: 2
                                    }
                                },
                                anchor: 'bottom'
                            }
                        } : {
                            type: 'Dialog',
                            containerProps: {
                                maxWidth: 'sm'
                            }
                        }), {}, {
                            Component: function (_ref) {
                                var onClose = _ref.onClose;
                                return /*#__PURE__*/ React.createElement(CancelDocument, {
                                    openPopper: openCancelPopUp,
                                    cancellationReasonAPI: GetCancellationReasonWPIList,
                                    cancelAPI: CancelWorkPurchaseInvoiceAPICall,
                                    id: rowId,
                                    handleClose: onClose
                                });
                            }
                        })))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            backgroundColor: systemColor.backgroundColor
        }
    }, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: viewTypeOptions
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            margin: {
                xs: '28px 0px 16px 0px !important',
                sm: '0px 0px 0px 0px !important'
            }
        }
    }, /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent
    // handleClickFilterIcon={handleClickFilterIcon}
    , {
        selectedMenuItem: selectedListVariant,
        menus: viewTypeOptions.length > 0 ? viewTypeOptions : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: (_crud$WorkPurchaseInv = crud[WorkPurchaseInvoiceKeys.Paging]) === null || _crud$WorkPurchaseInv === void 0 ? void 0 : _crud$WorkPurchaseInv.count,
        onClickCreateModule: function () {
            navigate('/createWorkPurchaseInvoice?mode=add');
        },
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.WorkPurchaseInvoice,
        pagingKey: WorkPurchaseInvoiceKeys.Paging
    })), activeView === 'list' && isDesktop && /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: WorkPurchaseInvoiceKeys.Paging,
        columns: customActionColumns,
        getPagingData: WPIPagingAPICall,
        pagingAPIRequest: getRequest(),
        dataGridProps: {
            onCellClick: function (params) {
                if (!(params.field === 'actions')) {
                    handleRowClick(params === null || params === void 0 ? void 0 : params.id);
                }
            },
            disableColumnMenu: false
        }
    })), (activeView === 'grid' || IS_MOBILE) && /*#__PURE__*/ React.createElement(Box, {
        py: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        pagingApiCall: WPIPagingAPICall,
        pagingKey: WorkPurchaseInvoiceKeys.Paging,
        pagingRequest: getRequest(),
        pageSize: 20,
        cardMapper: function (data) {
            return {
                id: "card-".concat(data.id),
                docNo: data.DocumentNumber,
                title: dateFormate(data.DocumentDate),
                statusName: data.Status,
                details: [{
                        label: "Supplier",
                        value: data === null || data === void 0 ? void 0 : data.SupplierName
                    }, {
                        label: "VIN reference:",
                        value: data === null || data === void 0 ? void 0 : data.VIN
                    }, {
                        label: "Job card reference no:",
                        value: data === null || data === void 0 ? void 0 : data.JobCardNo
                    }, {
                        label: "Service Advisor:",
                        value: data === null || data === void 0 ? void 0 : data.ServiceAdvisor
                    }]
            };
        },
        callIconVisibleFor: 'Supplier'
    })));
};
export default WorkPurchaseInvoice;
